import { h } from 'preact'
import { Fragment } from 'preact'
import { useRef, useEffect } from 'preact/hooks'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import useFirstRender from 'lib/useFirstRender'
import { DMChatListMember } from './DMChatListMember'
import { GeneralChatListMember } from './GeneralChatListMember'
import './index.sass'
import { useMyOrganizations } from 'lib/membershipAppStateHooks'


export function ChatsList({
  chatHref, myPublicProfile, organization, synopsis = [], currentChat, isPersonalChatPage, sortOption, filterOption,
  searchParam, forwarding, setChatChip, selectedChats, toggleChatSelection
}) {
  const firstRender = useFirstRender()

  console.log(filterOption, sortOption, 'filterOption, sortOption')

  const { myOrganizations } = useMyOrganizations('OrganizationChatPage')

  const chatsSelected = synopsis.filter(chatChannel => selectedChats?.has(chatChannel.uid))
    .map(chatChannel => ({
      ...chatChannel,
      key: chatChannel.uid,
      href: chatHref(chatChannel.uid),
      selected: (currentChat && currentChat.chatChannelUid === chatChannel.uid) || selectedChats.has(chatChannel.uid),
      orgName: (chatChannel.type === 'public_hub_chat' || chatChannel.type === 'private_hub_chat' ||
       chatChannel.type === 'public_hub_chat')
        ? myOrganizations.find(org => org.apikey === chatChannel.organizationApikey)?.name
        : null,
    }))


  useEffect(() => {
    setChatChip?.(chatsSelected)
  }, [selectedChats])

  const chats = synopsis
    .filter(chatChannel => !chatChannel.isDeletedForUser)

    .map(chatChannel => ({
      ...chatChannel,
      key: chatChannel.uid,
      href: chatHref(chatChannel.uid),
      // selected: currentChat && currentChat.chatChannelUid === chatChannel.uid,
      selected: (currentChat && currentChat.chatChannelUid === chatChannel.uid) || selectedChats?.has(chatChannel.uid),
      orgName: (chatChannel.type === 'private_hub_chat' ||
       chatChannel.type === 'public_hub_chat')
        ? myOrganizations.find(org => org.apikey === chatChannel.organizationApikey)?.name
        : null,
      displayName: chatChannel.type === 'dm' || chatChannel.type === 'direct_chat'
        ? chatChannel.name
        : myOrganizations.find(org => org.apikey === chatChannel.organizationApikey)?.name,
      memberUserDids: chatChannel.memberUserDids,
    }))
    .sort((a, b) => {
      if (a.is_pinned && !b.is_pinned) {
        return -1
      } else if (!a.is_pinned && b.is_pinned) {
        return 1
      } else {
        let aDate = new Date(a.latestAt || a.createdAt).getTime()
        let bDate = new Date(b.latestAt || b.createdAt).getTime()

        switch (sortOption) {
        case "AToZ":
          return a?.displayName.localeCompare(b?.displayName)
        case "ZToA":
          return b?.displayName.localeCompare(a?.displayName)
        case "OldestToNewest":
          return aDate - bDate
        case "NewestToOldest":
        default:
          return bDate - aDate
        }
      }
    })
    .filter(chat => {
      if (filterOption === 'all') {
        return true
      } else if (filterOption === 'dm') {
        return chat.type === 'direct_chat'
      } else if (filterOption === 'public_hub_chat') {
        return chat.type === 'private_hub_chat' || chat.type === 'public_hub_chat'
      } else if (filterOption === 'private_hub_chat') {
        return chat.type === 'private_hub_chat'
      } else if (filterOption === 'public_hub_chat') {
        return chat.type === 'public_hub_chat'
      }
      return true
    })
    .filter(chat => {
      if (!searchParam) {
        return true
      }
      const searchTermLower = searchParam.toLowerCase()
      const nameMatch = chat.name && typeof chat.name === 'string' &&
                       chat.name.toLowerCase().includes(searchTermLower)
      const displayNameMatch = chat.displayName && typeof chat.displayName === 'string' &&
                              chat.displayName.toLowerCase().includes(searchTermLower)
      const orgNameMatch = chat.orgName && typeof chat.orgName === 'string' &&
                          chat.orgName.toLowerCase().includes(searchTermLower)
      return nameMatch || displayNameMatch || orgNameMatch
    })

  if (currentChat && currentChat.dm) {
    chats.unshift({
      key: 'newDMChatChannel',
      type: 'dm',
      unread: 0,
      createdAt: new Date(),
      selected: true,
      href: `${global.location}`,
      memberUserDids: [currentChat.dm],
    })
  }

  useEffect(() => {
    if (chats.length > 0 &&
      !currentChat &&
      !forwarding &&
      firstRender) {

      const firstChat = chats[0]

      if (!firstChat || !firstChat.uid) return

      setTimeout(() => {
        if (window.history && window.history.pushState) {
          window.history.pushState({ chatId: firstChat.uid }, '', firstChat.href)
        }
        const customEvent = new CustomEvent('chatSelected', {
          bubbles: true,
          detail: {
            chatId: firstChat.uid,
            chatData: firstChat
          }
        })
        document.dispatchEvent(customEvent)
        if (window.dispatchEvent) {
          const popStateEvent = new PopStateEvent('popstate', {
            state: { chatId: firstChat.uid }
          })
          window.dispatchEvent(popStateEvent)
        }
      }, 50)
    }
  }, [chats, currentChat, forwarding, firstRender])

  const selectedIndex = chats.findIndex(chat => chat.selected)
  const rootRef = useRef()
  useEffect(
    () => {
      const node = rootRef.current.base
      const scrollTo = top => node.scrollTo({ top, behavior: firstRender ? undefined : 'smooth' })
      const selected = node.querySelector('.OrganizationChatPage-ChatListMember-selected')
      if (selected) {
        const { offsetTop, offsetHeight } = selected
        const { clientHeight, scrollTop } = node
        if (offsetTop < scrollTop || offsetTop > (scrollTop + clientHeight)) {
          scrollTo(offsetTop - (clientHeight / 3) + (offsetHeight / 2))
        }
      } else {
        scrollTo(0)
      }
    },
    [selectedIndex]
  )

  return <> <TransitionGroup ref={rootRef} className="OrganizationChatPage-ChatsList">
    {chats.map(chatChannel => <CSSTransition
      key={chatChannel.key}
      timeout={200}
      classNames="OrganizationChatPage-ChatsList-transition"
    >
      {h(
        chatChannel.type === 'public_hub_chat' ||
        chatChannel.type === 'private_hub_chat'
          ? GeneralChatListMember
          : DMChatListMember,
        {
          ...chatChannel,
          myPublicProfile,
          organization,
          isPersonalChatPage,
          forwarding,
          organizationApikey: chatChannel.organizationApikey,
          isSelected: selectedChats?.has(chatChannel.uid),
          onToggleSelection: () => toggleChatSelection(chatChannel.uid),
        }
      )}
    </CSSTransition>
    )}
  </TransitionGroup>
  </>
}
